/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step4_TitleInputs */

const es_landing_step4_title = /** @type {(inputs: Landing_Step4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibes a tus clientes`)
};

const gl_landing_step4_title = /** @type {(inputs: Landing_Step4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibes aos teus clientes`)
};

const en_landing_step4_title = /** @type {(inputs: Landing_Step4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome your guests`)
};

/**
* | output |
* | --- |
* | "Welcome your guests" |
*
* @param {Landing_Step4_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_step4_title = /** @type {((inputs?: Landing_Step4_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step4_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_step4_title(inputs)
	if (locale === "en") return en_landing_step4_title(inputs)
	return es_landing_step4_title(inputs)
});